import { AutocompleteInput, ReferenceInput, usePermissions, useTranslate } from 'react-admin';
import { DefaultBulkActionButtons } from '@/components/global/buttons/bulkButtons.jsx';
import FormDialog from '@/components/global/drawers/FormDialog.jsx';
import { aliasFilterToQuery } from '@/helpers/filters/filterToQuery.js';

export const GroupBulkActions = () => {
    const { permissions } = usePermissions();
    const translate = useTranslate();

    if (!permissions?.isAdmin) {
        return false;
    }

    return (
        <DefaultBulkActionButtons
            buttons={[
                <FormDialog key='FormDialog' title={translate('common.update')}>
                    <ReferenceInput name='targetSoftwareSocId' source='targetSoftwareSocId' reference='software-alias' filter={{ 'software.type': 'SOC' }}>
                        <AutocompleteInput filterToQuery={aliasFilterToQuery} fullWidth={true} label={translate('resources.device.labels.soc')} />
                    </ReferenceInput>
                    <ReferenceInput name='targetSoftwareMcuId' source='targetSoftwareMcuId' reference='software-alias' filter={{ 'software.type': 'MCU' }}>
                        <AutocompleteInput filterToQuery={aliasFilterToQuery} fullWidth={true} label={translate('resources.device.labels.mcu')} />
                    </ReferenceInput>
                </FormDialog>,
            ]}
        />
    );
};
